<template>
  <div class="d-flex flex-column gap-2">
    <div ref="messages" class="card flex-grow-1" :class="{'border-danger': !connected}" style="overflow-y: scroll; overflow-x: hidden">
      <div class="card-body">
        <div class="d-flex flex-column">
          <chat-message v-for="m in messages" :key="m.id" :message="m" :id="m.id"/>
        </div>
        <div v-if="parkButton" class="d-flex gap-2 flex-wrap">
          <button @click="sendMessage(parkButton)" class="btn btn-sm btn-outline-primary">{{ parkButton }}</button>
        </div>

        <div v-else-if="buttons" class="d-flex gap-2 flex-wrap">
          <button v-for="(button, i) in buttons" :key="i" @click="sendMessage(button)" class="btn btn-sm btn-primary">{{ button }}</button>
        </div>
      </div>
    </div>

    <div class="d-flex gap-2">
      <input @keydown.enter="sendMessage(text)" v-model="text" type="text" class="form-control" :disabled="!connected || parkButton">
      <button @click="sendMessage(text)" type="button" class="btn " :class="connected?'btn-primary':'btn-outline-secondary'" :disabled="!connected || !text || parkButton">Send</button>
    </div>

    <!--    <div v-if="!parkButton" class="d-flex gap-2">-->
    <!--      <input @keydown.enter="sendMessage(text)" v-model="text" type="text" class="form-control" :disabled="!connected">-->
    <!--      <button @click="sendMessage(text)" type="button" class="btn " :class="connected?'btn-primary':'btn-outline-secondary'" :disabled="!connected || !text">Send</button>-->
    <!--    </div>-->
    <!--    <div v-else class="d-flex flex-column gap-2">-->
    <!--      <button @click="sendMessage(parkButton)" type="button" class="btn btn-primary">{{ parkButton }}</button>-->
    <!--    </div>-->

  </div>

</template>

<script>
import ChatMessage from "@/components/widget/ChatMessage";
import {make_query} from "@/misc/http";

export default {
  components: {ChatMessage},
  props: ["pid", "uid", "meta", "chatServer", "secretToken"],
  provide(){
    return {
      widgetMethods:{
        sendMessage: (text)=>this.sendMessage(text),
      }
    }
  },
  data() {
    return {
      messages: [],
      text: "",
      connected: false,
      buttons: null,
      chatId: null,
      parkButton: null,
    }
  },

  created() {
    this.connect();
  },

  beforeUnmount() {
    this.disconnect();
  },

  methods: {

    connect() {
      this.chatId = localStorage.getItem("session" + this.uid);


      const serverUrl = this.chatServer + "/ws/chat/" + this.pid + "?" + make_query(this.meta);
      console.log("connecting, chatId=", this.chatId, "serverUrl=", serverUrl);

      this.socket = new WebSocket(serverUrl);

      this.socket.onopen = () => {
        this.connected = true;
        if (this.secretToken) this.socket.send(this.secretToken);
        this.socket.send(this.chatId || "hello");
      }

      this.socket.onmessage = (event) => {
        if (!this.chatId) { // should be first message in the chat
          console.log("got chatId", event.data);
          this.chatId = event.data; // todo token
          localStorage.setItem("session" + this.uid, this.chatId);
          return;
        }
        const message = JSON.parse(event.data);
        console.log("message", message);
        if (!message.ctl) {
          this.messages = [...this.messages, message]
              .sort((m1, m2) => m1.timestamp - m2.timestamp);
          this.buttons = this.messages.at(-1).buttons;
          this.doScroll(this.messages.at(-1).id);
        } else {

          console.log("Control message", message);

          switch (message.command) {
            case "reset_session":
              this.parkButton = null;
              this.chatId = message.newChatId;
              localStorage.setItem("session" + this.uid, this.chatId);
              if (!message.doNotClear)
                this.messages = [];
              break;
            case "park_session":
              this.parkButton = message.button;
              break;
          }
        }
      };


      this.socket.onerror = (err) => {
        this.disconnect();
        console.log("connect error", err);
      }

    },

    disconnect() {
      if (this.socket) {
        this.socket.close();
        this.socket = null;
        this.connected = false;
      }
    },

    sendMessage(text) {
      if (!text) return;
      this.text = "";
      if (!this.socket || this.socket.readyState != this.socket.OPEN) {
        console.log("error");
        if (this.socket) this.socket.close();
        this.socket = null;
        this.connected = false;
        return;  // todo: try reconnect
      }
      this.socket.send(text);
      this.buttons = null;
    },

    doScroll(id) {
      this.$nextTick(
          () => {
            document.getElementById(id).scrollIntoView({behavior: 'smooth'});
          }
      );
    },
  }
}
</script>

